module.exports = __webpack_public_path__ + "static/assets/74804ac7a067dad198b9e897ed611b41.svg";